module.exports = __webpack_public_path__ + "media/images/icon_sidebar_special-7b7f5410e4245362ccc73b0104ef235b.svg";